import { epochSecondsToDate, z } from '@customerio/hydra-validation';
import type { AnalyticsGoalsGoal as ApiGoal } from '@customerio/hydra-ui-api';
import { defineEntity, readSchema } from '../shared/define-entity';

/**
 * Goal entity — workspace-scoped.
 *
 * Minimal list+detail entity: `id` normalized to `string` (the wire ships a
 * number) and the epoch timestamps transformed to `Date`. A mutation surface
 * can be added when a consumer needs it — goal editing still lives in Ember.
 */
export type Goal = Omit<ApiGoal, 'id' | 'created_at' | 'updated_at'> & {
  id: string;
  created_at: Date;
  updated_at: Date;
};

const GoalFromApi = readSchema<Goal>(
  z.looseObject({
    id: z.number().transform(String),
    created_at: epochSecondsToDate,
    updated_at: epochSecondsToDate,
  }),
);

/** @public */
export const goal = defineEntity<Goal>({
  name: 'goal',
  scope: 'workspace',
  pk: (g) => g.id,
  schema: { read: GoalFromApi },
});

export const goalKeys = goal.keys;

export function parseGoal(raw: ApiGoal): Goal {
  return goal.parse(raw);
}
